// Türkiye 7 coğrafi bölge — müşteri/tedarikçi/şoför bölge filtresi (backend regions.py ile aynı liste)
export const TR_REGIONS = [
  "Marmara",
  "Ege",
  "Akdeniz",
  "İç Anadolu",
  "Karadeniz",
  "Doğu Anadolu",
  "Güneydoğu Anadolu",
];
